import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const REVIEWER_ASSIGNMENT_TEMPLATE = "reviewer-assignment";
export const FINAL_DELIVERY_TEMPLATE = "final-delivery";
export const AVAILABILITY_REQUEST_TEMPLATE = "availability-request";

const config = (user) => ({
  headers: { Authorization: `Bearer ${user.token}` },
  params: { cache_bust: new Date().getTime() },
});

export const getEmailTemplate = async (user, key) => {
  const response = await axios.get(`${BASE_URL}/email-templates/${key}`, config(user));
  return response.data;
};

// Deja pasar el error de axios: un 400 trae en `detail` qué está mal en la
// plantilla (variable desconocida, BCC o Reply-To inválido) y la pantalla lo muestra.
export const updateEmailTemplate = async (user, key, { subject, body, bcc, reply_to }) => {
  const response = await axios.put(
    `${BASE_URL}/email-templates/${key}`,
    { subject, body, bcc, reply_to },
    config(user)
  );
  return response.data;
};
